<template>
  <div class="group relative">
    <div class="identity-alert-phone-input">
      <input
        ref="identityAlertPhoneInput"
        type="tel"
        class="pl-80px w-full rounded-md border-2 border-transparent bg-off-white p-4 text-sm focus:outline-none"
        :value="phoneValue"
        placeholder="Enter phone number"
        @input="handleInput"
      />
    </div>
  </div>
</template>

<script>
import { formatPhone } from '@/common/validators';
import intlTelInput from 'intl-tel-input';
import * as utilsScript from '../../node_modules/intl-tel-input/build/js/utils.js';

export default {
  name: 'IdentityAlertPhoneInput',
  props: {
    modelValue: String,
    pattern: String,
    onBlur: Function,
    readyToSubmit: Boolean,
    autoValue: {
      type: String,
      required: false,
    },
  },
  emits: ['update:modelValue', 'update-country-code'],
  data() {
    return {
      phoneValue: null,
      iti: null,
    };
  },
  computed: {
    placeholder() {
      return '';
    },
  },
  watch: {
    iti(newVal) {
      if (newVal && this.iti) {
        const countryCode = this.iti.getSelectedCountryData().dialCode;
        this.$emit('update-country-code', countryCode);
      }
    },
  },
  mounted() {
    this.iti = intlTelInput(this.$refs?.identityAlertPhoneInput, {
      separateDialCode: true,
      preferredCountries: ['us'],
      autoPlaceholder: 'off',
      formatOnDisplay: true,
      utilsScript,
    });

    this.$refs?.identityAlertPhoneInput.addEventListener(
      'countrychange',
      (e) => {
        this.countryValidate(e);
      }
    );

    if (this.autoValue && this.autoValue?.length > 0) {
      this.iti.setNumber(this.autoValue);
      let valueInitial = this.autoValue;
      let dialCodeInitial = this.iti.getSelectedCountryData()?.dialCode;
      dialCodeInitial = '+' + dialCodeInitial;
      this.phoneValue = formatPhone(valueInitial.replace(dialCodeInitial, ''));
      this.$emit(
        'updateCountryCode',
        this.iti.getSelectedCountryData()?.dialCode
      );
    }
  },
  beforeUnmount() {
    if (this.$refs.inputField) {
      this.$refs.inputField.removeEventListener(
        'countrychange',
        this.countryValidate
      );
    }
  },
  methods: {
    countryValidate(e) {
      console.log(e);
      const countryCode = document
        ?.getElementsByClassName('iti__selected-dial-code')?.[0]
        ?.innerHTML?.replace('+', '');
      if (!countryCode) return;
      this.$emit('updateCountryCode', parseInt(countryCode));
    },
    blurValidation(value) {
      return value;
    },
    handleInput($event) {
      const value = formatPhone($event.target.value);
      this.phoneValue = value;
      this.$emit(
        'update-country-code',
        this.iti.getSelectedCountryData()?.dialCode
      );
      this.$emit('update:modelValue', this.iti.getNumber());
    },
  },
};
</script>

<style scoped>
input {
  background: #f7f7fa;
  border: 1px solid #f7f7fa;
  border-radius: 5px;
  color: #313545;
}

input:hover {
  border: 1px solid #c7cbdb;
}

input::placeholder {
  color: #a9adbd;
}

input:focus {
  border: 2px solid #6d7181;
  background: white;
  color: #6d7181;
}
</style>
